<!-- 
<body>
    <IMG src=http://p.fenglist.com/l/fengliebiaologo.gif width=0 height=0></IMG>
</body> -->

<template>
  <nav class="menu-container">
    丰列表<br>
    fengliebiao.com<br>
  分享出行信息,<br>
  更多功能请点击左边导航！<br>
  <IMG src=http://p.fenglist.com/l/fengliebiaologo.gif width=0 height=0></IMG>  <!--能显示的 -->
    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    <!-- 丰列表<br>
  分享出行信息,更多功能请点击左边导航！<br>
  <IMG src=http://p.fenglist.com/l/fengliebiaologo.gif width=0 height=0></IMG> -->
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        // {
        //   name: "",
        //   title: "",
        //   // icon: "chat",
        //   exact: true,
        // },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>

<!--
<script>
export default {};
</script>

<script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-6381475828765939" crossorigin="anonymous"></script>


<ins class="adsbygoogle" style="display:block" data-ad-client="ca-pub-6381475828765939" data-ad-slot="6953278123" data-ad-format="auto" data-full-width-responsive="true"></ins>
<script> (adsbygoogle = window.adsbygoogle || []).push({}); </script>

<style></style> -->
